import { env } from "~/env";
import { NIRVANA_STATUS, NirvanaCheckResult } from "~/services/nirvana/types";
import { NotificationBanner } from "~/ui/notification-banner/notification-banner";

type CoverageStatusBannerProps = {
  result: NirvanaCheckResult | null;
};

export const CoverageStatusBanner = ({ result }: CoverageStatusBannerProps) => {
  if (!result || result.status === NIRVANA_STATUS.SKIPPED) {
    return null;
  }

  const payerName = result.payerName?.trim() || null;

  if (result.status === NIRVANA_STATUS.COVERED) {
    return (
      <NotificationBanner variant="success">
        Your visit is covered
        {payerName ? (
          <>
            {" "}
            by <span className="font-medium">{payerName}</span>
          </>
        ) : null}
        .
      </NotificationBanner>
    );
  }

  if (result.status === NIRVANA_STATUS.NOT_COVERED) {
    return (
      <NotificationBanner variant="warning">
        Your visit is not covered
        {payerName ? (
          <>
            {" "}
            by <span className="font-medium">{payerName}</span>
          </>
        ) : null}
        . The cost of this visit is ${env.VITE_INITIAL_VISIT_COST}.
      </NotificationBanner>
    );
  }

  // inconclusive (plan could not be identified / verification failed)
  return (
    <NotificationBanner variant="success">
      Your insurance information has been received. You&apos;re all set to
      continue.
    </NotificationBanner>
  );
};
